'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _select = require('./select');

var _select2 = _interopRequireDefault(_select);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmailSelect = function (_Select) {
  _inherits(EmailSelect, _Select);

  function EmailSelect() {
    _classCallCheck(this, EmailSelect);

    var _this = _possibleConstructorReturn(this, (EmailSelect.__proto__ || Object.getPrototypeOf(EmailSelect)).call(this));

    var originalHandleKeyDown = _this.handleKeyDown;
    var originalSearch = _this.search;

    _this.handleKeyDown = function (event) {
      _this.emailSelectHandleKeyDown(event);
      originalHandleKeyDown(event);
    };

    _this.search = function (event) {
      originalSearch(event);
      _this.emailSelectSearch(event);
    };

    _this.handleEditableChipOnChange = function (value, option) {
      _this.emailSelectHandleEditableChipOnChange(value, option);
    };
    return _this;
  }

  _createClass(EmailSelect, [{
    key: 'emailSelectHandleKeyDown',
    value: function emailSelectHandleKeyDown(event) {
      if (event.key === _utils.KEYS.TAB) {
        this.handleTabKey(event);
      }
    }
  }, {
    key: 'handleTabKey',
    value: function handleTabKey(event) {
      var _this2 = this;

      event.preventDefault();
      var searchValue = this.state.searchValue;

      this.setState({
        searchValue: this.modifySearchValue(searchValue)
      }, function () {
        _this2.handleEnterKey(event);
      });
    }
  }, {
    key: 'emailSelectSearch',
    value: function emailSelectSearch(event) {
      var _this3 = this;

      var value = event.target.value;
      var multipleOptions = this.state.multipleOptions;


      if (this.ifGmailMail(value)) {
        var strippedValue = this.stripCommas(this.convertFromGmailFormat(value));
        this.setState({ multipleOptions: multipleOptions.concat(strippedValue), searchValue: '' }, function () {
          if (_this3.props && _this3.props.onSelection) {
            _this3.props.onSelection(_this3.state.multipleOptions);
          }
        });
      }

      if (value.search(',') > 0) {
        var allValues = value.split(',');
        var cleanValues = allValues.filter(Boolean).map(function (str) {
          return _this3.stripCommas(_this3.convertFromGmailFormat(str));
        });
        var uniqueMultipleOptions = new Set(multipleOptions.concat(cleanValues));
        this.setState({ multipleOptions: [].concat(_toConsumableArray(uniqueMultipleOptions)), searchValue: '' }, function () {
          if (_this3.props && _this3.props.onSelection) {
            _this3.props.onSelection([].concat(_toConsumableArray(uniqueMultipleOptions)));
          }
        });
      }
    }
  }, {
    key: 'emailSelectHandleEditableChipOnChange',
    value: function emailSelectHandleEditableChipOnChange(event, option) {
      var _this4 = this;

      var value = event.target.value;
      var multipleOptions = this.state.multipleOptions;


      if (this.ifGmailMail(value)) {
        var editedMultipleOptionsList = [].concat(multipleOptions);
        var strippedValue = this.stripCommas(this.convertFromGmailFormat(value));
        editedMultipleOptionsList[editedMultipleOptionsList.findIndex(function (el) {
          return el === option;
        })] = strippedValue;
        this.setState({ multipleOptions: editedMultipleOptionsList }, function () {
          if (_this4.props && _this4.props.onSelection) {
            _this4.props.onSelection(_this4.state.multipleOptions);
          }
        });
      }

      if (value.search(',') > 0) {
        var multipleOptionClone = [].concat(multipleOptions);
        var indexOfChangedValue = multipleOptionClone.findIndex(function (el) {
          return el === option;
        });
        var allValues = value.split(',');
        var cleanValues = allValues.filter(Boolean).map(function (str) {
          return _this4.stripCommas(_this4.convertFromGmailFormat(str));
        });
        var uniqueNewMultipleOptions = [].concat(_toConsumableArray(new Set(cleanValues)));
        var editedMultipleOptionsArray = multipleOptionClone.slice(0, indexOfChangedValue).concat(uniqueNewMultipleOptions).concat(multipleOptionClone.slice(indexOfChangedValue + 1));

        this.setState({ multipleOptions: [].concat(_toConsumableArray(new Set(editedMultipleOptionsArray))) }, function () {
          if (_this4.props && _this4.props.onSelection) {
            _this4.props.onSelection(_this4.state.multipleOptions);
          }
        });
      }
    }
  }, {
    key: 'modifySearchValue',
    value: function modifySearchValue(str) {
      return this.stripCommas(this.convertFromGmailFormat(str));
    }
  }, {
    key: 'stripCommas',
    value: function stripCommas(v) {
      return v.replace(',', '');
    }
  }, {
    key: 'convertFromGmailFormat',
    value: function convertFromGmailFormat(v) {
      var gmailFormatList = v.match(/<([^<>]+)>/g);

      if (gmailFormatList && gmailFormatList.length) {
        var strippedArray = gmailFormatList.map(function (item) {
          return item.replace(/^</, '').replace(/>$/, '');
        });

        return strippedArray.toString();
      }
      return v;
    }
  }, {
    key: 'ifGmailMail',
    value: function ifGmailMail(v) {
      return (/<([^<>]+)>/g.test(v)
      );
    }
  }]);

  return EmailSelect;
}(_select2.default);

exports.default = EmailSelect;